import React from 'react';
import { useHistory } from 'react-router-dom';

import InputPhone from '../../../Components/InputPhone';
import { Form, InputGroup, Step, Title } from '../style';
import { SignInError } from './../../../Theme/index';

export default function StepOne() {
  const history = useHistory();
  const [isErrorPhoneFormat, setIsErrorPhoneFormat] = React.useState(false);

  React.useEffect(() => {
    localStorage.setItem('signInData', null);
  }, []);

  function handleSubmit(event) {
    event.preventDefault();
    setIsErrorPhoneFormat(false);
    const name = event.target.user_name.value;
    const phone = event.target.user_phone.value.replace(/\D/g, '');

    if (!/(\d{2})(\d{4,5})(\d{4})/g.test(phone)) {
      setIsErrorPhoneFormat(true);
      return;
    }

    if (window.fbq) {
      window.fbq("track", "StepOneRegistration");
    }

    const data = {
      name,
      phone,
    };
    localStorage.setItem('signInData', JSON.stringify(data));
    history.push('step-two');
  }

  return (
    <Step>
      <Title>
        Vamos iniciar o <br /> seu teste?
      </Title>
      <Form onSubmit={handleSubmit}>
        <InputGroup>
          <label>Qual o seu nome?</label>
          <input
            required
            type='text'
            placeholder='ex: João Freitas'
            name='user_name'
          />
        </InputGroup>
        <InputGroup>
          <label>Qual o seu telefone para contato?</label>
          <InputPhone
            required
            type='text'
            placeholder='ex: 11 98987-8998'
            name='user_phone'
          />
        </InputGroup>
        {isErrorPhoneFormat && (
          <SignInError style={{ color: 'red' }}>
            Por favor preencha o telefone corretamente
          </SignInError>
        )}

        <button type='submit'>Sim</button>
      </Form>
    </Step>
  );
}
